<template>
<tr>
  <td>{{ tender.date | moment('DD/MM/YYYY')}} </td>
  <td>{{ received_tender_results[0].award_date | moment('DD/MM/YYYY')}} </td>
  <td v-b-tooltip.hover title="Ver Licitación completa">
    <router-link :to="{
      name: 'procurement',
      params: {
        id: tender.id
        }
      }"
      >
      {{ tender.summary }}
      </router-link>
  </td>
  <td> {{ tender.title }} </td>
  <td>
    <ul>
      <li v-for="(cpv_code, cpvIndex) in tender.cpv_codes" v-bind:key="`cpv_code_${cpvIndex}`">
        {{cpv_code}}
      </li>
    </ul>
  </td>
  <td>{{ locationStr(tender.location) }}</td>
  <td>
    <template v-if="tender.has_lots === false">
      {{ formatAmount(tender.tax_exclusive_amount) }}
    </template>
    <template v-else>
      <ul>
        <li> <strong>Total Lotes:</strong>  {{ formatAmount(tender.tax_exclusive_amount) }} </li>

        <li> <strong>Total Lotes Ganados:</strong>  {{ formatAmount(total_expected_amount) }} </li>
      </ul>
    </template>
  </td>
  <td>
    {{ formatAmount(total_received_amount) }}
  </td>
  <td>
    {{formatAmount(Math.abs(total_expected_amount - total_received_amount))}}
    <template v-if="total_expected_amount - total_received_amount >= 0">
      <strong template v-if="(total_expected_amount - total_received_amount) > 0">
        (-{{(((total_expected_amount - total_received_amount) *100)/ (total_expected_amount)).toFixed()}} %)
      </strong>
    </template>
    <template v-else>
      <strong template v-if="total_expected_amount > 0">
        (+{{(((total_received_amount - total_expected_amount) *100)/ (total_expected_amount)).toFixed()}} %)
      </strong>
    </template>
  </td>
  <td>
    <template v-if="tender.has_lots === false">
      {{ received_tender_results.length > 0 ? received_tender_results[0].description : '' }}
    </template>
    <template v-else>
      <p>Total lotes licitación: {{ tender.lots.length }}</p>
      <p>Lotes ganados: {{ received_lots.length }}</p>
      <ul>
        <li v-for="(lot, lotIndex) in received_lots" v-bind:key="`received_lot_${lotIndex}`">
          <strong>ID Lote:</strong> {{lot.lot_id}} <br/>
          <strong>Resumen:</strong> {{lot.summary}} <br/>
          <strong>Razón de adjudicación:</strong> {{lot.result_description}} <br/>
          <strong>Fecha Adjudicación:</strong> {{lot.award_date | moment('DD/MM/YYYY')}} <br/>
          <strong>Importe Total Lote:</strong> {{formatAmount(lot.bidding_tax_exclusive_amount)}} <br/>
          <strong>Importe Adjudicación:</strong> {{formatAmount(lot.tax_exclusive_amount)}}
          <strong template v-if="lot.bidding_tax_exclusive_amount - lot.tax_exclusive_amount > 1">(-{{(((lot.bidding_tax_exclusive_amount - lot.tax_exclusive_amount) *100)/ lot.bidding_tax_exclusive_amount).toFixed()}} %)</strong>
          <hr v-if="lotIndex < received_lots.length - 1"/>
        </li>
      </ul>
    </template>
  </td>
  <td>
    <template v-if="tender.contracting_party && tender.contracting_party">
      <router-link :to="{
        name: 'procurement_party',
        params: {
        id: tender.contracting_party.id
            }
          }">
        {{tender.contracting_party.name}}
      </router-link>
    </template>
  </td>
</tr>
</template>

<script>
import procurementMixin from '@/_mixins/procurement.mixin';

export default {
  name: 'procurementPartyTenderResultsRow',
  mixins: [procurementMixin],
  props: ['tender'],
  computed: {
    received_tender_results() {
      return this.tender.tender_results.filter(tr => tr.awarded_party.id == this.$route.params.id);
    },
    received_lots() {
      const rlots = [];
      if (this.tender.lots.length === 0) {
        return rlots;
      }

      this.tender.lots.forEach((lot) => {
        const lot_result = this.received_tender_results.find(tr => tr.lot_id === lot.lot_id);
        if (lot_result) {
          rlots.push({
            award_date: lot_result.award_date,
            tax_exclusive_amount: lot_result.tax_exclusive_amount,
            bidding_tax_exclusive_amount: lot.tax_exclusive_amount,
            result_description: lot_result.description,
            summary: lot.summary,
            lot_id: lot.lot_id,
          });
        }
      });
      return rlots;
    },
    total_received_amount() {
      if (this.received_tender_results.length === 0) {
        return 0;
      }

      return this.received_tender_results.reduce((sum, tr) => sum + tr.tax_exclusive_amount, 0);
    },
    total_expected_amount() {
      if (this.tender.has_lots) {
        return this.received_lots.reduce((sum, lot) => sum + lot.bidding_tax_exclusive_amount, 0);
      }

      return this.tender.tax_exclusive_amount;
    },
    percentage_difference_with_tender_amount() {
      if (this.total_expected_amount === 0) {
        return 0;
      }

      return ((this.total_received_amount - this.total_expected_amount) / this.total_expected_amount) * 100;
    },
  },
};
</script>

<style scoped>

.party{
  padding: 30px;
}
h1{
  display:inline-block;
  margin-left: 5px;
}
.fa-external-link-alt {
  color:#000000;
}
.fa-external-link-alt:hover {
  cursor:pointer;
  color:#4953CF;
}
</style>
